import { useLocation } from "react-router-dom";

import { SectionSubNav } from "@/components/ui/admin/SectionSubNav";

interface SectionShellProps {
  basePath: string;
  children: React.ReactNode;
}

export function SectionShell({ basePath, children }: SectionShellProps) {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-0 flex-1 flex-col lg:flex-row">
      <div className="hidden lg:flex">
        <SectionSubNav
          basePath={basePath}
          pathname={pathname}
          orientation="vertical"
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="lg:hidden">
          <SectionSubNav
            basePath={basePath}
            pathname={pathname}
            orientation="horizontal"
          />
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
